import { FC, useEffect } from "react"

import { getCookie, isClientSide } from "@utils"

const CookieCheck: FC = () => {
  useEffect(() => {
    if (!isClientSide()) return

    const TEST_ID = "MarketingPricingHeroNov25"
    const TEST_COOKIE_ID = "hs_marketing_pricinghero_nov25"
    const cookieValue = getCookie(TEST_COOKIE_ID)

    if (!cookieValue) return

    const signupLinks = document.querySelectorAll("a[href^='https://secure.helpscout.net/members/register']")
    signupLinks.forEach(link => {
      const linkUrl = new URL(link.href)
      console.log(linkUrl, linkUrl.searchParams)
      linkUrl.searchParams.set("hs_tvar", `${TEST_ID}-${cookieValue.split("#")[1]}`)
      link.href = linkUrl.toString()
    })
  }, [])
  return null
}

export default CookieCheck
